import type { Station } from '~models/station.model';

export const getStationFullAddress = (station: Station): string => {
  const { address } = station;

  if (!address) return '';

  const { street, city, postalCode } = address;

  return [street, city, postalCode].filter((addressPart) => addressPart !== null && addressPart !== '').join(', ');
};

/** Returns Statin.name fallbacked by a full address */
export const getStationName = (station?: Station | null): string => {
  if (!station) return '';

  return station?.name ?? getStationFullAddress(station);
};
